import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import SimulationImg from '../../../components/SimulationImg';
import { inject, observer } from 'mobx-react';
import { factorMapStr } from '@/utils/contants/caseSimulation';
import SwipeContainer from '@/components/Mobile/Swipe';

const FactorImage = (props) => {
    const { simulation } = props.store;
    const { curSection = {}, sections = [], handleChangeCurSection, currentViewIndex } = simulation;
    const [cardData, setCardData] = useState([]);
    // 计算左侧和右侧卡片的索引（循环逻辑）
    const getLeftIndex = (curIndex) => {
        // 中间项索引 -1，若小于0则取最后一个
        if (curIndex === 0) {
            return sections.length - 1;
        }
        return curIndex - 1;
    };

    const getRightIndex = (curIndex) => {
        if (curIndex === sections.length - 1) {
            return 0;
        }
        return curIndex + 1;
    };

    const getCardData = (curIndex) => {
        const leftIndex = getLeftIndex(curIndex);
        const rightIndex = getRightIndex(curIndex);

        return [sections[leftIndex], sections[curIndex], sections[rightIndex]];
    };
    const onCurSectionChange = (card) => {
        let index = sections.findIndex((item) => item.section_id === card.section_id);
        let data = getCardData(index);

        setCardData(data);
    };
    const onSwipeLeft = (card, viewIndex) => {
        //如果视图index不是1，不允许滑动,只允许滑动中间项的卡片
        if (viewIndex !== 1) {
            return;
        }
        console.log('视图上的index', viewIndex);
        let index = card?.originalIndex;
        if (index === sections.length - 1) {
            index = 0;
        } else {
            index = ++index;
        }
        handleChangeCurSection(sections[index]);
    };
    const onSwipeRight = (card, viewIndex) => {
        if (viewIndex !== 1) {
            return;
        }
        let index = card?.originalIndex;
        if (index === 0) {
            // 如果没有完整划过最后一张卡片，不允许滑动
            if (currentViewIndex !== sections.length - 1) {
                return;
            }
            index = sections.length - 1;
        } else {
            index = --index;
        }
        handleChangeCurSection(sections[index]);
    };

    useEffect(() => {
        if (curSection.section_id) {
            onCurSectionChange(curSection);
        }
    }, [curSection.section_id]);
    return (
        <>
            {/* 主图片区域 */}
            <div className={styles.imageContainer}>
                {cardData.map((item, index) => {
                    return (
                        <SwipeContainer
                            onSwipeLeft={() => {
                                onSwipeLeft(item, index);
                            }}
                            onSwipeRight={() => {
                                onSwipeRight(item, index);
                            }}
                            dataIndex={index}
                            className={styles.swipeContainer}
                            key={item.section_id}
                        >
                            <SimulationImg
                                key={item.section_id}
                                data-index={index}
                                data-canload={currentViewIndex >= item.originalIndex}
                                src={item?.image}
                                alt=""
                                className={styles.sectionImage}
                            />
                        </SwipeContainer>
                    );
                })}
            </div>
            <div className={styles.curSectionInfo}>
                <div className={styles.Index}>
                    {sections.map((item) => (
                        <div key={item.section_id} className={styles.indexItem} data-active={item.section_id === curSection.section_id}></div>
                    ))}
                </div>
                <div className={styles.des}>
                    <span className={styles.factorName}>（{factorMapStr[curSection?.section_id]}）</span>
                    <span className={styles.factorTitle}>{curSection?.title}</span>
                </div>
            </div>
        </>
    );
};

export default inject('store')(observer(FactorImage));
